export const headerValidations = (headers: any, requiredHeaders: any) => {
  let error = '';
  const cleanHeaders = headers?.map((header: any) =>
    header
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^\w\s]/gi, '')
  );
  if (!cleanHeaders.includes(requiredHeaders?.name?.toLowerCase())) {
    error = 'nameRequired';
  }
  if (!cleanHeaders.includes(requiredHeaders?.lastName?.toLowerCase())) {
    error = 'lastNameRequired';
  }
  if (!cleanHeaders.includes(requiredHeaders?.email?.toLowerCase())) {
    error = 'emailRequired';
  }
  if (
    !cleanHeaders.includes(requiredHeaders?.name?.toString().toLowerCase()) &&
    !cleanHeaders.includes(
      requiredHeaders?.lastName?.toString().toLowerCase()
    ) &&
    !cleanHeaders.includes(requiredHeaders?.email?.toString().toLowerCase())
  ) {
    error = 'headersRequired';
  }
  return error;
};

export const headerBonusValidations = (headers: any, requiredHeaders: any) => {
  let error = '';
  const cleanHeaders = headers?.map((header: any) =>
    header
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^\w\s]/gi, '')
  );
  if (!cleanHeaders.includes(requiredHeaders?.email?.toLowerCase())) {
    error = 'emailRequired';
  }
  if (!cleanHeaders.includes(requiredHeaders?.socialNetwork?.toLowerCase())) {
    error = 'socialNetworkRequired';
  }
  if (!cleanHeaders.includes(requiredHeaders?.url?.toLowerCase())) {
    error = 'urlRequired';
  }
  if (!cleanHeaders.includes(requiredHeaders?.points?.toLowerCase())) {
    error = 'pointsRequired';
  }
  if (!cleanHeaders.includes(requiredHeaders?.status?.toLowerCase())) {
    error = 'statusRequired';
  }
  if (
    !cleanHeaders.includes(requiredHeaders?.email?.toString().toLowerCase()) &&
    !cleanHeaders.includes(
      requiredHeaders?.socialNetwork?.toString().toLowerCase()
    ) &&
    !cleanHeaders.includes(requiredHeaders?.url?.toString().toLowerCase()) &&
    !cleanHeaders.includes(requiredHeaders?.points?.toString().toLowerCase()) &&
    !cleanHeaders.includes(requiredHeaders?.status?.toString().toLowerCase())
  ) {
    error = 'headersRequired';
  }
  return error;
};
